import React from 'react';
import { Input, Divider, ColorPicker } from 'antd';
import Table from "../../../../components/EditableTable";
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { getBathtubWidthTableData } from '../../../../services/Andes_v2/results/simulation/dataHelper';

const defaultColumns = [
  {
    title: "Signal",
    dataIndex: "signalName",
    key: "signalName"
  },
  {
    title: "Curve",
    dataIndex: "curveName",
    key: "curveName",
    render: (value, record) => {
      return <>
        <ColorPicker
          value={record.color}
          disabled
          className='aurora-color-picker-small'
          size='small'
        />
        <span>{value}</span>
      </>
    },
    onCell: (record) => ({
      colSpan: typeof record.colSpan === 'number' && record.colSpan === 3 ? 0 : 1,
    })
  },
  {
    title: "Bathtub Width",
    dataIndex: "width",
    key: "width",
    onCell: (record) => ({
      colSpan: typeof record.colSpan === 'number' && record.colSpan === 3 ? 0 : 1,
    })
  }
]

class BathtubWidthTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      tableData: [],
      expandSignals: [], // expand signal names,
      berValue: 1e-10,
      widthShow: true,
      inputBerValue: null
    }

    this.firstUpdate = true;
  }

  initData = (portSelect, _xUnit) => {
    const { berValue, expandSignals: stateExpandSignals } = this.state;
    const { resultList, xUnit: propsXUnit } = this.props;

    const xUnit = _xUnit ? _xUnit : propsXUnit;
    const expandSignals = this.firstUpdate ? resultList.show : stateExpandSignals;
    const columns = this.updateColumns(expandSignals);
    const tableData = getBathtubWidthTableData({ list: resultList.list, expandSignals, berValue, xUnit });
    this.setState({ tableData, expandSignals, columns }, () => {
      this.drawWidthLine(tableData, portSelect);
    });
    this.firstUpdate = false;
  }

  updateColumns = (expandSignals) => {
    const columns = defaultColumns.map(item => {
      if (item.dataIndex === 'signalName') {
        return {
          ...item,
          render: (value) => {
            return (
              <div className='bathtub-width-table-signal'>
                {
                  !expandSignals.includes(value)
                    ? <RightOutlined className='expand-icon' onClick={() => this.expandSignal(value)} />
                    : <DownOutlined className='expand-icon' onClick={() => this.expandSignal(value)} />
                }
                <span title={value} className='signal-name'>{value}</span>
              </div>
            )
          },
          onCell: (record) => ({
            rowSpan: typeof record.rowSpan === 'number' ? record.rowSpan : 1,
            colSpan: typeof record.colSpan === 'number' ? record.colSpan : 1,
          })
        }
      }

      return item;
    })

    return columns;
  }

  expandSignal = (signalName) => {
    const { xUnit, portSelect } = this.props;
    const { expandSignals } = this.state;
    const newExpandSignals = expandSignals.includes(signalName) ? expandSignals.filter(item => item !== signalName) : [...expandSignals, signalName];
    this.setState({ expandSignals: newExpandSignals }, () => {
      this.initData(portSelect, xUnit);
    });
  }

  // The enter/out-of-focus event triggers the update of tableData data
  saveBERValue = () => {
    const { expandSignals, inputBerValue } = this.state;
    const { resultList, xUnit, portSelect } = this.props;
    if (isNaN(inputBerValue)) {
      this.setState({ inputBerValue: null, error: "Pleace input the number value." });
      return;
    }
    const tableData = getBathtubWidthTableData({ list: resultList.list, expandSignals, berValue: inputBerValue, xUnit });
    this.setState({ tableData, inputBerValue: null, error: "", berValue: inputBerValue }, () => {
      this.drawWidthLine(tableData, portSelect);
    });
  }

  drawWidthLine = (_tableData, portSelect = {}) => {
    const tableData = _tableData ? _tableData : this.state.tableData;
    const arrowLine = tableData
      .filter(item => portSelect[item.signalName] && portSelect[item.signalName].includes(item.id))
      .map(t => t.drawLine)
      .filter(it => it && Object.keys(it).length);
    this.props.setBathtubVoltageWidthLine(arrowLine)
  }

  render() {
    const { columns, tableData, berValue, widthShow, inputBerValue, error } = this.state;
    return <div className="bathtub-width-table-content">
      <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }}>
        <div className='result-import-title' onClick={() => this.setState({ widthShow: !widthShow })}>
          {widthShow ? <DownOutlined className="title-expand-icon" /> : <RightOutlined className="title-expand-icon" />}
          <span className='sparameter-result-menu-title'>Bathtub Width at BER</span>
        </div>
      </Divider>
      {widthShow ? <>
        <div className='bathtub-width-table-input-box'>
          <span>BER</span>
          <Input
            value={typeof inputBerValue === 'string' ? inputBerValue : berValue}
            onFocus={(() => this.setState({ inputBerValue: berValue }))}
            onChange={(e) => this.setState({ inputBerValue: e.target.value })}
            onPressEnter={(e) => { e.target.blur(); this.saveBERValue(); }}
            onBlur={this.saveBERValue}
          />
        </div>
        {error ? <div className='bathtub-width-table-error-tip'>{error}</div> : null}
        <Table
          rowKey={(record) => `${record.signalName}-${record.curveName}`}
          columns={columns}
          dataSource={tableData}
        />
      </> : null}
    </div>
  }
}

export default BathtubWidthTable;